import React from "react";
import data from "../json/Allproducts/Xpertreview.json";
import Section1 from "../components/Allproducts/Section1";
import Section2 from "../components/Allproducts/Section2";
import Section4 from "../components/Allproducts/Section4";

const Xpertreview = () => {
  return (
    <div className="w-full flex flex-col items-center ruler">

      <Section1 data={data}/>
      <Section2 data={data.Section3}/>
      <Section4 data={data.Section4}/>
    </div>
  );
};

export default Xpertreview;
